import React from 'react';
import Image from 'next/image';
import { Star } from 'lucide-react';

const testimonials = [
  {
    name: 'Jessica L.',
    avatar: 'https://res-front.pumpsoul.com/ins-prod/image/picture-43567891.webp',
    content:
      'This unfollowers tracker on Instagram is a game-changer! I finally know how to see who unfollowed me, and it’s so easy to use. Highly recommend!',
    rating: 5,
  },
  {
    name: 'David K.',
    avatar: 'https://res-front.pumpsoul.com/ins-prod/image/picture-43567892.webp',
    content:
      'I’ve tried many tools, but this one stands out. It’s the best way to track Instagram unfollowers and manage my account efficiently.',
    rating: 5,
  },
  {
    name: 'Ryan M.',
    avatar: 'https://res-ins.pumpsoul.com/ins_image/1715232201493612730.jpg',
    content:
      'Thanks to this tool, I can keep track of who doesn’t follow me back on Instagram. It’s fast, reliable, and doesn’t require any app downloads!',
    rating: 5,
  },
];

const Testimonials: React.FC = () => {
  return (
    <section className="py-12 ">
      <div className="container mx-auto px-4">
        <div className="text-3xl font-bold text-center mb-20">What Our Users Say</div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-lg  shadow-lg hover:shadow-xl transition-shadow duration-300"
            >
              <div className="flex items-center mb-4">
                <Image
                  src={testimonial.avatar}
                  alt={testimonial.name}
                  width={80}
                  height={80}
                  className="rounded-full"
                />
                <div className="ml-4">
                  <div className="font-semibold text-lg">{testimonial.name}</div>
                  <div className="flex items-center">
                    {[...Array(5)].map((_, i) => (
                      <Star
                        key={i}
                        className={`w-4 h-4 ${
                          i < testimonial.rating ? 'text-yellow-400 fill-current' : 'text-gray-300'
                        }`}
                      />
                    ))}
                  </div>
                </div>
              </div>
              <p className="text-gray-700 italic">&ldquo;{testimonial.content}&rdquo;</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
